export { default as PointLogo24x24Icon } from './point_logo_24x24.svg';
export { default as PointLogo28x28Icon } from './point_logo_28x28.svg';
